import { Button, Grid, Typography } from '@mui/material';
import './error.ui.scss';
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Composant pour la page d'erreur 404
 * @param props
 * @constructor
 */
export default function ErrorUi(props: { img: string; title: string; msg: string }) {
    return (
        <Grid className="containerError" container spacing={6}>
            <Grid item xs={12}>
                <Typography variant="h4" sx={{ marginTop: 6 }}>
                    {props.title}
                </Typography>
                <Typography variant="body1" color="text.primary">
                    {props.msg}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <img className="image_404" src={props.img} alt="Error 404" />
            </Grid>
            <Grid item xs={12}>
                <Button component={Link} to={'/'} variant="contained">
                    Retour sur l'accueil
                </Button>
            </Grid>
        </Grid>
    );
}
